import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons';

import { listItemPropTypes, reorderableListItem } from 'helpers/react_dnd/reorderable_list';
import ListingRow from './listing_row';
import { saveListingOrder, localReorder } from './actions';

export class PinnedListingRow extends React.Component {
  static propTypes = {
    ...listItemPropTypes,
    listing: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })
  }

  renderDragSource() {
    return this.props.connectDragSource(
      <span className="cursor-move px-3">
        <FontAwesomeIcon icon={faEllipsisV}/>
      </span>
    );
  }

  render() {
    const { listing } = this.props;
    const style = {
      opacity: this.props.isDragging ? 0 : 1,
    };

    return this.props.connectDragPreview(this.props.connectDropTarget(
      <div style={style}>
        <ListingRow dragSource={this.renderDragSource()} listing={listing} pinned/>
      </div>
    ));
  }
}

const mapStateToProps = ({ module }) => ({
  updatingListingId: module.updatingListingId
});

const mapDispatchToProps = {
  onEndDrag: saveListingOrder,
  onReorder: localReorder
};

export default connect(mapStateToProps, mapDispatchToProps)(reorderableListItem(PinnedListingRow, 'pinnedListingRow', {
  beginDrag(props) {
    return {
      id: props.listing.id,
      index: props.index
    };
  },
  endDrag(props, monitor) {
    props.onEndDrag(props, monitor);
  }
}));
